import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './PaQuickQuoteVehicle-hashed.scss';
import templateStr from 'text!./PaQuickQuoteVehicle.html';
import asyncLookup from 'edge/quoteandbind/quickquote/pa/util/AsyncLookup';

export default ['VinLookupService', '$q', '$filter', 'quickquote.QuickQuoteService',
    (VinLookupService, $q, $filter, QuickQuoteService) => {
        return {
            restrict: 'E',
            scope: {
                vehicle: '=',
                isActive: '&',
                isPanelValid: '&',
                transitionFn: '&',
                flow: '='
            },
            template: cssUtil.hashTemplate(templateStr, styles),

            controller: ['$scope', ($scope) => {
                $scope.hideVIN = {value: true};
                $scope.invalidVIN = true;
                $scope.vinInstructionsDisplayed = false;
                $scope.vehicleVin = {};
                $scope.allowedFileTypes = '.png,.jpg';

                const makeLookup = asyncLookup(() =>
                    VinLookupService.lookupMakes().then(vehicleInfo => {
                        $scope.vehicle.make.aspects.availableValues = vehicleInfo.makes;
                    }));
                makeLookup.load();

                const modelLookup = asyncLookup(make =>
                    VinLookupService.autofillBasedOnPartialDto({
                        make
                    }).then(vehicleInfo => {
                        $scope.vehicle.model.aspects.availableValues = vehicleInfo.models;
                    }));

                const yearsLookup = asyncLookup((make, model) =>
                    VinLookupService.autofillBasedOnPartialDto({
                        make, model
                    }).then(vehicleInfo => {
                        $scope.vehicle.year.aspects.availableValues = vehicleInfo.years;
                    }));

                function populateVehicleValues(vehicleInfo) {
                    $scope.vehicle.make.value = vehicleInfo.make;
                    $scope.vehicle.model.value = vehicleInfo.model;
                    $scope.vehicle.year.value = vehicleInfo.year;
                    if (vehicleInfo.vin) {
                        $scope.vehicle.vin.value = vehicleInfo.vin;
                    }
                }

                function setErrorMessage(errorMessage) {
                    $scope.errorMsg = errorMessage;
                }

                function autofillVehicleInformation(vehicleInfo) {
                    if (vehicleInfo && vehicleInfo.make && vehicleInfo.model && vehicleInfo.year) {
                        // Autofill with the returned data
                        $scope.invalidVIN = false;
                        populateVehicleValues(vehicleInfo);
                        setErrorMessage('');
                    } else {
                        // The VIN does not return a match, VIN is invalid
                        $scope.invalidVIN = true;
                        populateVehicleValues('', '', undefined);
                    }
                    $scope.showLoading = false;
                }

                $scope.$watch('vehicle.make.value', (newVal) => {
                    modelLookup.load(newVal);
                });

                $scope.$watch('vehicle.model.value', (newVal) => {
                    yearsLookup.load($scope.vehicle.make.value, newVal);
                });

                $scope.lookupVIN = () => {
                    if ($scope.vehicle.vin.value && $scope.vehicle.vin.value.length > 0) {
                        $scope.showLoading = true;
                        $q.when(VinLookupService.autofillBasedOnVIN($scope.vehicle.vin.value), (vehicleInfo) => {
                            autofillVehicleInformation(vehicleInfo);
                            $scope.showLoading = false;
                        }, () => {
                            // Something has gone legitimately wrong, let the user input the data manually
                            setErrorMessage($filter('translate')('quoteandbind.quickquote.pa.directives.Vehicle.errorMsg'));
                            $scope.showLoading = false;
                            $scope.invalidVIN = null;
                        });
                    } else {
                        $scope.invalidVIN = true;
                        setErrorMessage('');
                        populateVehicleValues('', '', undefined);
                    }
                };

                $scope.toggleVinInstructions = () => {
                    $scope.vinInstructionsDisplayed = !$scope.vinInstructionsDisplayed;
                };

                $scope.$watch('vehicleVin.file', (uploadedFile) => {
                    if (uploadedFile !== undefined) {
                        $q.when(QuickQuoteService.extractTextAndLookupVin(uploadedFile), (vehicleInfo) => {
                            autofillVehicleInformation(vehicleInfo);
                            $scope.showLoading = false;
                        }, () => {
                            // Something has gone legitimately wrong, let the user input the data manually
                            setErrorMessage($filter('translate')('quoteandbind.quickquote.pa.directives.Vehicle.errorMsg'));
                            $scope.showLoading = false;
                            $scope.invalidVIN = null;
                        });
                    }
                });
            }],
        };
    }
];
